module.exports = __webpack_public_path__ + "img/five2.658ecb87.png";